<zimmerer-route-ion-wrapper class="ion-page">

  <div class="threecol" fxLayout="column" fxLayoutAlign.gt-md="center center">
    <div class="main-col withBottomPadding" [class.withTopPadding]="mobileService.isMobile"
      [class.noSlider]="!hasSliderImages" fxLayout="column" fxLayoutGap="20px">

      <image-slider [fxHide]="!hasSliderImages" [page]="'career'" fxHide.lt-lg></image-slider>

      <div class="section" *ngIf="careers.length > 0 else noCareers;">
        <h4>Hier findest du aktuell offene Stellen beim Zimmerer-Treffpunkt. Hast Du Fragen dazu und Interesse den
          Zimmerer-Treffpunkt mitzugestalten? Dann schreib uns per Mail an <a href="mailto:info@zimmerer-treff.com">info@zimmerer-treff.com</a> oder ruf uns einfach
          an unter <a href="tel:+4999519574700">+49 (0) 9951 9574700.</a></h4>

        <div class="grid">
          <job-card *ngFor="let career of careers" [entity]="career" #impressionAnchor data-entitytype="Job"
            data-id="{{career.id}}">
          </job-card>
        </div>
      </div>

      <ng-template #noCareers>
        <h4>Aktuell keine offenen Stellen.</h4>
      </ng-template>
    </div>
  </div>

  <app-footer></app-footer>

</zimmerer-route-ion-wrapper>